import { render, staticRenderFns } from "./ContentDefault.vue?vue&type=template&id=15d476ce&scoped=true&"
import script from "./ContentDefault.vue?vue&type=script&lang=js&"
export * from "./ContentDefault.vue?vue&type=script&lang=js&"
import style0 from "./ContentDefault.vue?vue&type=style&index=0&id=15d476ce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d476ce",
  null
  
)

export default component.exports